export default "__VITE_ASSET__CU2rGHcy__"